export var SET_FORM = 'SET_FORM';
export var ADD_FORM_STEP = 'ADD_FORM_STEP';
export var SET_FORM_INFO = 'SET_FORM_INFO';
export var RESET_FORM_STATE = 'RESET_FORM_STATE';
export var SET_PROGRESS_FORM = 'SET_PROGRESS_FORM';
export var SET_DOCUMENT_DATA_REVIEW = 'SET_DOCUMENT_DATA_REVIEW';
